const verses = [
  "In the Name of God, the Most Ancient, the Most Great.",

  "Indeed the hearts of the sincere are consumed in the fire of separation: Where is the gleaming of the light of Thy Countenance, O Beloved of the worlds?",

  "Those who are near unto Thee have been abandoned in the darkness of desolation: Where is the shining of the morn of Thy reunion, O Desire of the worlds?",

  "The bodies of Thy chosen ones lie quivering on distant sands: Where is the ocean of Thy presence, O Enchanter of the worlds?",

  "Longing hands are uplifted to the heaven of Thy grace and generosity: Where are the rains of Thy bestowal, O Answerer of the worlds?",

  "The infidels have arisen in tyranny on every hand: Where is the compelling power of Thine ordaining pen, O Conqueror of the worlds?",

  "The barking of dogs is loud on every side: Where is the lion of the forest of Thy might, O Chastiser of the worlds?",

  "Coldness hath gripped all mankind: Where is the warmth of Thy love, O Fire of the worlds?",

  "Calamity hath reached its height: Where are the signs of Thy succor, O Salvation of the worlds?",

  "Darkness hath enveloped most of the peoples: Where is the brightness of Thy splendor, O Radiance of the worlds?",

  "The necks of men are stretched out in malice: Where are the swords of Thy vengeance, O Destroyer of the worlds?",

  "Abasement hath reached its lowest depth: Where are the emblems of Thy glory, O Glory of the worlds?",

  "Sorrows have afflicted the Revealer of Thy Name, the All-Merciful: Where is the joy of the Dayspring of Thy Revelation, O Delight of the worlds?",

  "Anguish hath befallen all the peoples of the earth: Where are the ensigns of Thy gladness, O Joy of the worlds?",

  "Thou seest the Dawning Place of Thy signs veiled by evil suggestions: Where are the fingers of Thy might, O Power of the worlds?",

  "Sore thirst hath overcome all men: Where is the river of Thy bounty, O Mercy of the worlds?",

  "Greed hath made captive all mankind: Where are the embodiments of detachment, O Lord of the worlds?",

  "Thou seest this Wronged One lonely in exile: Where are the hosts of the heaven of Thy Command, O Sovereign of the worlds?",

  "I have been forsaken in a foreign land: Where are the emblems of Thy faithfulness, O Trust of the worlds?",

  "The agonies of death have laid hold on all men: Where is the surging of Thine ocean of eternal life, O Life of the worlds?",

  "The whisperings of Satan have been breathed to every creature: Where is the meteor of Thy fire, O Light of the worlds?",

  "The drunkenness of passion hath perverted most of mankind: Where are the daysprings of purity, O Desire of the worlds?",

  "Thou seest this Wronged One veiled in tyranny among the Syrians: Where is the radiance of Thy dawning light, O Light of the worlds?",

  "Thou seest Me forbidden to speak forth: Then from where will spring Thy melodies, O Nightingale of the worlds?",

  "Most of the people are enwrapped in fancy and idle imaginings: Where are the exponents of Thy certitude, O Assurance of the worlds?",

  "Bahá is drowning in a sea of tribulation: Where is the Ark of Thy salvation, O Savior of the worlds?",

  "Thou seest the Dayspring of Thine utterance in the darkness of creation: Where is the sun of the heaven of Thy grace, O Light-Giver of the worlds?",

  "The lamps of truth and purity, of loyalty and honor, have been put out: Where are the signs of Thine avenging wrath, O Mover of the worlds?",

  "Canst Thou see any who have championed Thy Self, or who ponder on what hath befallen Him in the pathway of Thy love? Now doth My pen halt, O Beloved of the worlds.",

  "The branches of the Divine Lote-Tree lie broken by the onrushing gales of destiny: Where are the banners of Thy succor, O Champion of the worlds?",

  "This Face is hidden in the dust of slander: Where are the breezes of Thy compassion, O Mercy of the worlds?",

  "The robe of sanctity is sullied by the people of deceit: Where is the vesture of Thy holiness, O Adorner of the worlds?",

  "The sea of grace is stilled for what the hands of men have wrought: Where are the waves of Thy bounty, O Desire of the worlds?",

  "The door leading to the Divine Presence is locked through the tyranny of Thy foes: Where is the key of Thy bestowal, O Unlocker of the worlds?",

  "The leaves are yellowed by the poisoning winds of sedition: Where is the downpour of the clouds of Thy bounty, O Giver of the worlds?",

  "The universe is darkened with the dust of sin: Where are the breezes of Thy forgiveness, O Forgiver of the worlds?",

  "This Youth is lonely in a desolate land: Where is the rain of Thy heavenly grace, O Bestower of the worlds?",

  "O Supreme Pen, We have heard Thy most sweet call in the eternal realm: Give Thou ear unto what the Tongue of Grandeur uttereth, O Wronged One of the worlds!",

  "Were it not for the cold, how would the heat of Thy words prevail, O Expounder of the worlds?",

  "Were it not for calamity, how would the sun of Thy patience shine, O Light of the worlds?",

  "Lament not because of the wicked. Thou wert created to bear and endure, O Patience of the worlds.",

  "How sweet was Thy dawning on the horizon of the Covenant among the stirrers of sedition, and Thy yearning after God, O Love of the worlds.",

  "By Thee the banner of independence was planted on the highest peaks, and the sea of bounty surged, O Rapture of the worlds.",

  "By Thine aloneness the Sun of Oneness shone, and by Thy banishment the land of Unity was adorned. Be patient, O Thou Exile of the worlds.",

  "We have made abasement the garment of glory, and affliction the adornment of Thy temple, O Pride of the worlds.",

  "Thou seest the hearts are filled with hate, and to overlook is Thine, O Thou Concealer of the sins of the worlds.",

  "When the swords flash, go forward! When the shafts fly, press onward! O Thou Sacrifice of the worlds.",

  "Dost Thou wail, or shall I wail? Rather shall I weep at the fewness of Thy champions, O Thou Who hast caused the wailing of the worlds.",

  "Verily, I have heard Thy Call, O All-Glorious Beloved; and now is the face of Bahá flaming with the heat of tribulation and with the fire of Thy shining word, and He hath risen up in faithfulness at the place of sacrifice, looking toward Thy pleasure, O Ordainer of the worlds.",

  "O ‘Alí-Akbar, thank thy Lord for this Tablet whence thou canst breathe the fragrance of My meekness, and know what hath beset Us in the path of God, the Adored of all the worlds.",

  "Should all the servants read and ponder this, there shall be kindled in their veins a fire that shall set aflame the worlds.",
];
const baha = "Bahá’u’lláh";

export { verses, baha };
